<template>
  <div class="embed-form">
    <h4 class="embed-form__heading">Embed</h4>
    <p>
      Copy the code bellow to embed the entire visualization in your website.
    </p>
    <textarea class="form-control embed-form__code mb-4" readonly>{{ overviewCode }}</textarea>
  </div>
</template>

<script>
  export default {
    methods: {
      codeFor () {
        const parts = [...arguments]
        return `<iframe  width="100%" height="700" src="${parts.join('')}" frameborder="0" allowfullscreen></iframe>`
      }
    },
    computed: {
      host () {
        const protocol = window.location.protocol
        const slashes = protocol.concat('//')
        return slashes.concat(window.location.host)
      },
      overviewCode () {
        const route = this.$router.resolve({ name: 'overview' })
        return this.codeFor(this.host, window.location.pathname, route.href)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmbedForm.vue?31e817c4